module.exports = __webpack_public_path__ + "static/img/HT.8ebc0937.png";